export const normalizeTicketingDateEntries = (entries) => {
    if (!Array.isArray(entries)) return entries;
    const numericFields = ['departureWindow', 'daysAfterReservation', 'daysBeforeDeparture'];
    return entries.map((entry) => {
        const normalized = { ...entry };
        numericFields.forEach((field) => {
            const value = normalized[field];
            if (value === '' || value === null || value === undefined) {
                normalized[field] = '';
            } else {
                normalized[field] = Number(value);
            }
        });
        return normalized;
    });
};
